/**
 * Analytics identifiers for SHED & OUTBUILDING PLANS™.
 * Leave a value empty to keep that integration switched off.
 */
export const META_PIXEL_ID = '1083116574356174'
export const CLARITY_PROJECT_ID = ''
export const FACEBOOK_DOMAIN_VERIFICATION = ''
